<div *ngIf="loadingService.progressBar$ | async" class="row gx-0">
    <div class="progress animated-progress loading-progress progress-sm">
        <div class="progress-bar bg-danger" role="progressbar" [style.width.%]="loadingService.progress"
            aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
</div>